__webpack_require__.p = "https://gamma.sg.safer.whs.amazon.dev/";